/* eslint-disable camelcase */
import axios from 'axios'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const _ = require('lodash')

export default {
  checkCreateButtonPermission: function (actionPermission: any, createIdCondition: any, userDetail: any, enableAdministratorPermissionByDefault: any): boolean {
    let createConditions = ''
    let disableCreateButton = false
    let createConditionFieldValue = ''
    let createConditionValue

    // eslint-disable-next-line eqeqeq
    if (enableAdministratorPermissionByDefault == '1') {
      return true
    }

    if (!_.isEmpty(createIdCondition)) {
      createIdCondition.forEach((condition: any, index: number) => {
        if (!_.isEmpty(condition['condition_field']) && !_.isEmpty(condition['condition_op']) && !_.isEmpty(condition['condition_value'])) {
          // eslint-disable-next-line eqeqeq
          if (condition['condition_field'] == 'role_id') {
            createConditionFieldValue = userDetail.roles[0].id
          } else {
            createConditionFieldValue = (_.isNumber(userDetail[condition['condition_field']])) ? userDetail[condition['condition_field']] : '"' + userDetail[condition['condition_field']] + '"'
          }
        } else {
          createConditionFieldValue = (_.isNumber(userDetail[condition['condition_field']])) ? userDetail[condition['condition_field']] : '"' + userDetail[condition['condition_field']] + '"'
          // console.log('createConditionFieldValue::', index, createConditionFieldValue)
        }

        if (condition['condition_op'] === 'in') {
          createConditionValue = condition['condition_value'].split(',')
          if (createConditionValue.includes(createConditionFieldValue.toString())) {
            createConditionValue = createConditionFieldValue
          } else {
            createConditionValue = 0
          }
          condition['condition_op'] = '=='
        } else {
          createConditionValue = (_.isNumber(condition['condition_value'])) ? condition['condition_value'] : '"' + condition['condition_value'] + '"'
        }

        switch (condition['joining_rules']) {
          case 'NA':
          case 'AND':
            createConditions += '(' + createConditionFieldValue + condition['condition_op'] + createConditionValue + ') && '
            break
          case 'OR':
            createConditions += '(' + createConditionFieldValue + condition['condition_op'] + createConditionValue + ') || '
            break
        }
      })

      createConditions = this.rtrim(this.rtrim(createConditions, ' && '), ' || ')

      if (!_.isEmpty(createConditions) && actionPermission.includes('Create') && this.check(createConditions)) {
        disableCreateButton = true
      }
    }

    return disableCreateButton
  },
  checkEditButtonPermission: function (actionPermission: any, editIdCondition: any, editRefidCondition: any, editCustomCondition: any, data: any, userDetail: any, enableAdministratorPermissionByDefault: any, relationBetweenConditionBlock: any = { "list_refid" : "&&", "edit_id" : "&&", "edit_refid" : "&&", "delete_id" : "&&", "delete_refid" : "&&" }): boolean {
    let editRefidConditions = ''
    let editRefidConditionValue = ''
    let editRefidConditionFieldValue = ''
    let editCustomConditions = ''
    let condition_value
    let editConditionValue
    let edit_custom_condition_field
    let editConditionFieldValue

    // eslint-disable-next-line eqeqeq
    if (enableAdministratorPermissionByDefault == '1') {
      return true
    }

    editRefidCondition.forEach((condition: any, index: number) => {
      if (!_.isEmpty(condition['condition_field']) && !_.isEmpty(condition['condition_op'])) {
        editRefidConditionValue = (data.creator[condition['condition_field']]) ? '"' + data.creator[condition['condition_field']] + '"' : ''
        editRefidConditionFieldValue = (userDetail[condition['condition_field']]) ? '"' + userDetail[condition['condition_field']] + '"' : ''
        if (!_.isEmpty(editRefidConditionValue) && !_.isEmpty(editRefidConditionFieldValue)) {
          switch (condition['joining_rules']) {
            case 'NA':
            case 'AND':
              editRefidConditions += (condition['condition_op'] === 'like') ? _.startsWith(editRefidConditionFieldValue, editRefidConditionValue) + ' && ' : '(' + editRefidConditionFieldValue + condition['condition_op'] + editRefidConditionValue + ') && '
              break
            case 'OR':
              editRefidConditions += (condition['condition_op'] === 'like') ? _.startsWith(editRefidConditionFieldValue, editRefidConditionValue) + ' || ' : '(' + editRefidConditionFieldValue + condition['condition_op'] + editRefidConditionValue + ') || '
              break
          }
        }
      }
    })

    editRefidConditions = this.rtrim(this.rtrim(editRefidConditions, ' && '), ' || ')

    editCustomCondition.forEach((condition: any, index: number) => {
      if (!_.isEmpty(condition['edit_custom_condition_field']) && !_.isEmpty(condition['condition_op']) && !_.isEmpty(condition['condition_value'])) {
        condition_value = condition.hasOwnProperty('condition_value') && (condition['condition_value']) ? condition['condition_value'] : ''
        editConditionValue = _.isNumber(condition_value) ? condition_value : '"' + condition_value + '"'

        edit_custom_condition_field = (data[condition['edit_custom_condition_field']]) ? data[condition['edit_custom_condition_field']] : ''
        editConditionFieldValue = _.isNumber(edit_custom_condition_field) ? edit_custom_condition_field : '"' + edit_custom_condition_field + '"'

        if ((editConditionValue) && (editConditionFieldValue)) {
          switch (condition['joining_rules']) {
            case 'NA':
            case 'AND':
              editCustomConditions += (condition['condition_op'] === 'like') ? _.startsWith(editConditionFieldValue, editConditionValue) + " && " : "(" + editConditionFieldValue + condition['condition_op'] + editConditionValue + ") && ";
              break
            case 'OR':
              editCustomConditions += (condition['condition_op'] === 'like') ? _.startsWith(editConditionFieldValue, editConditionValue) + " || " : "(" + editConditionFieldValue + condition['condition_op'] + editConditionValue + ") || ";
              break
          }
        }
      }
    })

    editCustomConditions = this.rtrim(this.rtrim(editCustomConditions, ' && '), ' || ');

    let editConditions = ''
    let condition_field
    let conditionValue

    editIdCondition.forEach((condition: any, index: number) => {
      if ((!_.isEmpty(condition['condition_field']) && !_.isEmpty(condition['condition_op']) && !_.isEmpty(condition['condition_value'])) ||
          (!_.isEmpty(condition['edit_condition_table_field']))) {
        condition_field = (userDetail[condition['condition_field']]) ? userDetail[condition['condition_field']] : ''

        editConditionFieldValue = _.isNumber(condition_field) ? condition_field : '"' + condition_field + '"'
        // eslint-disable-next-line no-prototype-builtins
        conditionValue = condition.hasOwnProperty('condition_value') && !_.isEmpty(condition['condition_value']) ? condition['condition_value'] : data[condition['edit_condition_table_field']]
        if (condition['condition_op'] === 'in') {
          editConditionValue = conditionValue.split(',')
          if (editConditionValue.includes(userDetail[condition['condition_field']].toString())) {
            editConditionValue = editConditionFieldValue
          } else {
            editConditionValue = 0
          }
          condition['condition_op'] = '=='
        } else {
          conditionValue = (conditionValue) ? conditionValue : ''
          editConditionValue = _.isNumber(conditionValue) ? conditionValue : '"' + conditionValue + '"'
        }

        if ((editConditionValue) && (editConditionFieldValue)) {
          switch (condition['joining_rules']) {
            case 'NA':
            case 'AND':
              editConditions += '(' + editConditionFieldValue + condition['condition_op'] + editConditionValue + ') && '
              break
            case 'OR':
              editConditions += '(' + editConditionFieldValue + condition['condition_op'] + editConditionValue + ') || '
              break
          }
        }
      }
    })

    editConditions = this.rtrim(this.rtrim(editConditions, ' && '), ' || ')

    let disableEditButton = false

    if (_.isEmpty(editConditions) && _.isEmpty(editCustomConditions) && !_.isEmpty(editRefidConditions) && actionPermission.includes('Edit') &&
      this.check(editRefidConditions)) {
      disableEditButton = true
    }

    if (_.isEmpty(editConditions) && !_.isEmpty(editCustomConditions) && _.isEmpty(editRefidConditions) && actionPermission.includes('Edit') &&
      this.check(editCustomConditions)) {
      disableEditButton = true
    }

    if (_.isEmpty(editConditions) && !_.isEmpty(editCustomConditions) && !_.isEmpty(editRefidConditions) && actionPermission.includes('Edit')) {
      const blockConditionOperator = _.isEmpty(relationBetweenConditionBlock['edit_refid']) ? '&&' : relationBetweenConditionBlock['edit_refid']
      switch (blockConditionOperator) {
        case '||':
          if (this.check(editCustomConditions) || this.check(editRefidConditions)) {
            disableEditButton = true
          }
          break
        default:
          if (this.check(editCustomConditions) && this.check(editRefidConditions)) {
            disableEditButton = true
          }
          break
      }
    }

    /* if (_.isEmpty(editConditions) && !_.isEmpty(editCustomConditions) && !_.isEmpty(editRefidConditions) && actionPermission.includes("Edit")
      && this.check(editCustomConditions) && this.check(editRefidConditions)) {
      disableEditButton = true;
    } */

    if (!_.isEmpty(editConditions) && _.isEmpty(editCustomConditions) && _.isEmpty(editRefidConditions) && actionPermission.includes('Edit') &&
      this.check(editConditions)) {
      disableEditButton = true
    }

    if (!_.isEmpty(editConditions) && _.isEmpty(editCustomConditions) && !_.isEmpty(editRefidConditions) && actionPermission.includes('Edit')) {
      // disableEditButton = true;
      const blockConditionOperator = _.isEmpty(relationBetweenConditionBlock['edit_id']) ? '&&' : relationBetweenConditionBlock['edit_id']
      switch (blockConditionOperator) {
        case '||':
          if (this.check(editConditions) || this.check(editRefidConditions)) {
            disableEditButton = true
          }
          break
        default:
          if (this.check(editConditions) && this.check(editRefidConditions)) {
            disableEditButton = true
          }
          break
      }
    }

    /* if (!_.isEmpty(editConditions) && _.isEmpty(editCustomConditions) && !_.isEmpty(editRefidConditions) && actionPermission.includes("Edit")
      && this.check(editConditions) && this.check(editRefidConditions)) {
      disableEditButton = true;
    } */

    if (!_.isEmpty(editConditions) && !_.isEmpty(editCustomConditions) && _.isEmpty(editRefidConditions) && actionPermission.includes('Edit')) {
      // disableEditButton = true;
      const blockConditionOperator = _.isEmpty(relationBetweenConditionBlock['edit_id']) ? '&&' : relationBetweenConditionBlock['edit_id']
      switch (blockConditionOperator) {
        case '||':
          if (this.check(editConditions) || this.check(editCustomConditions)) {
            disableEditButton = true
          }
          break
        default:
          if (this.check(editConditions) && this.check(editCustomConditions)) {
            disableEditButton = true
          }
          break
      }
    }

    /* if (!_.isEmpty(editConditions) && !_.isEmpty(editCustomConditions) && _.isEmpty(editRefidConditions) && actionPermission.includes("Edit")
      && this.check(editConditions) && this.check(editCustomConditions)) {
      disableEditButton = true;
    } */

    if (!_.isEmpty(editConditions) && !_.isEmpty(editCustomConditions) && !_.isEmpty(editRefidConditions) && actionPermission.includes('Edit')) {
      // disableEditButton = true;
      const blockIdConditionOperator = _.isEmpty(relationBetweenConditionBlock['edit_id']) ? '&&' : relationBetweenConditionBlock['edit_id']
      const blockRefIdConditionOperator = _.isEmpty(relationBetweenConditionBlock['edit_refid']) ? '&&' : relationBetweenConditionBlock['edit_refid']
      switch (true) {
        // eslint-disable-next-line eqeqeq
        case ((blockIdConditionOperator == '||') && (blockRefIdConditionOperator == '||')):
          if (this.check(editConditions) || this.check(editRefidConditions) || this.check(editCustomConditions)) {
            disableEditButton = true
          }
          break
          // eslint-disable-next-line eqeqeq
        case (blockIdConditionOperator == '||'):
          if ((this.check(editConditions) || this.check(editRefidConditions)) && this.check(editCustomConditions)) {
            disableEditButton = true
          }
          break
        // eslint-disable-next-line eqeqeq
        case (blockRefIdConditionOperator == '||'):
          if (this.check(editConditions) && (this.check(editRefidConditions) || this.check(editCustomConditions))) {
            disableEditButton = true
          }
          break
        default:
          if (this.check(editConditions) && this.check(editCustomConditions) && this.check(editRefidConditions)) {
            disableEditButton = true
          }
          break
      }
    }

    /* if (!_.isEmpty(editConditions) && !_.isEmpty(editCustomConditions) && !_.isEmpty(editRefidConditions) && actionPermission.includes("Edit")
      && this.check(editConditions) && this.check(editCustomConditions) && this.check(editRefidConditions)) {
      disableEditButton = true;
    } */

    return disableEditButton
  },
  checkDeleteButtonPermission: function (actionPermission: any, deleteIdCondition: any, deleteRefidCondition: any, deleteCustomCondition: any, data: any, userDetail: any, enableAdministratorPermissionByDefault: any, relationBetweenConditionBlock: any = {"list_refid" : "&&", "edit_id" : "&&", "edit_refid" : "&&", "delete_id" : "&&", "delete_refid" : "&&"}): boolean {
    let deleteRefidConditions = ''
    let deleteRefidConditionValue
    let deleteRefidConditionFieldValue

    // eslint-disable-next-line eqeqeq
    if (enableAdministratorPermissionByDefault == '1') {
      return true
    }

    deleteRefidCondition.forEach((condition: any, index: number) => {
      if (!_.isEmpty(condition['condition_field']) && !_.isEmpty(condition['condition_op'])) {
        deleteRefidConditionValue = (data.creator[condition['condition_field']]) ? '"' + data.creator[condition['condition_field']] + '"' : ''
        deleteRefidConditionFieldValue = (userDetail[condition['condition_field']]) ? '"' + userDetail[condition['condition_field']] + '"' : ''

        if (!_.isEmpty(deleteRefidConditionValue) && !_.isEmpty(deleteRefidConditionFieldValue)) {
          switch (condition['joining_rules']) {
            case 'NA':
            case 'AND':
              deleteRefidConditions += (condition['condition_op'] === 'like') ? _.startsWith(deleteRefidConditionFieldValue, deleteRefidConditionValue) + ' && ' : '(' + deleteRefidConditionFieldValue + condition['condition_op'] + deleteRefidConditionValue + ') && '
              break
            case 'OR':
              deleteRefidConditions += (condition['condition_op'] === 'like') ? _.startsWith(deleteRefidConditionFieldValue, deleteRefidConditionValue) + ' || ' : '(' + deleteRefidConditionFieldValue + condition['condition_op'] + deleteRefidConditionValue + ') || '
              break
          }
        }
      }
    })

    deleteRefidConditions = this.rtrim(this.rtrim(deleteRefidConditions, ' && '), ' || ')

    let deleteCustomConditions = ''
    let condition_value
    let deleteConditionValue
    let delete_custom_condition_field
    let deleteConditionFieldValue = ''
    deleteCustomCondition.forEach((condition: any, index: number) => {
      if (!_.isEmpty(condition['delete_custom_condition_field']) && !_.isEmpty(condition['condition_op']) && !_.isEmpty(condition['condition_value'])) {
        // eslint-disable-next-line no-prototype-builtins
        condition_value = condition.hasOwnProperty('condition_value') && (condition['condition_value']) ? condition['condition_value'] : ''
        deleteConditionValue = _.isNumber(condition_value) ? condition_value : '"' + condition_value + '"'
        delete_custom_condition_field = (data[condition['delete_custom_condition_field']]) ? data[condition['delete_custom_condition_field']] : ''
        deleteConditionFieldValue = _.isNumber(delete_custom_condition_field) ? delete_custom_condition_field : '"' + delete_custom_condition_field + '"'

        if ((deleteConditionValue) && (deleteConditionFieldValue)) {
          switch (condition['joining_rules']) {
            case 'NA':
            case 'AND':
              deleteCustomConditions += (condition['condition_op'] === 'like') ? _.startsWith(deleteConditionFieldValue, deleteConditionValue) + ' && ' : '(' + deleteConditionFieldValue + condition['condition_op'] + deleteConditionValue + ') && '
              break
            case 'OR':
              deleteCustomConditions += (condition['condition_op'] === 'like') ? _.startsWith(deleteConditionFieldValue, deleteConditionValue) + ' || ' : '(' + deleteConditionFieldValue + condition['condition_op'] + deleteConditionValue + ') || '
              break
          }
        }
      }
    })

    deleteCustomConditions = this.rtrim(this.rtrim(deleteCustomConditions, ' && '), ' || ')

    let deleteConditions = ''
    let condition_field
    let conditionValue

    deleteIdCondition.forEach((condition: any, index: number) => {
      if (
        !_.isEmpty(condition['condition_field']) && !_.isEmpty(condition['condition_op']) && (
          (!_.isEmpty(condition['condition_value']) && _.isEmpty(condition['condition_value'] !== '')) ||
            (!_.isEmpty(condition['delete_condition_table_field']))
        )) {
        condition_field = (userDetail[condition['condition_field']]) ? userDetail[condition['condition_field']] : ''
        deleteConditionFieldValue = _.isNumber(condition_field) ? condition_field : '"' + condition_field + '"'
        // eslint-disable-next-line no-prototype-builtins
        conditionValue = condition.hasOwnProperty('condition_value') && !_.isEmpty(condition['condition_value']) ? condition['condition_value'] : data[condition['delete_condition_table_field']]

        if (condition['condition_op'] === 'in') {
          deleteConditionValue = conditionValue.split(',')
          if (deleteConditionValue.includes(userDetail[condition['condition_field']].toString())) {
            deleteConditionValue = deleteConditionFieldValue
          } else {
            deleteConditionValue = 0
          }

          condition['condition_op'] = '=='
        } else {
          conditionValue = (conditionValue) ? conditionValue : ''
          deleteConditionValue = _.isNumber(conditionValue) ? conditionValue : '"' + conditionValue + '"'
        }
        if ((deleteConditionValue) && (deleteConditionFieldValue)) {
          switch (condition['joining_rules']) {
            case 'NA':
            case 'AND':
              deleteConditions += '(' + deleteConditionFieldValue + condition['condition_op'] + deleteConditionValue + ') && '
              break
            case 'OR':
              deleteConditions += '(' + deleteConditionFieldValue + condition['condition_op'] + deleteConditionValue + ') || '
              break
          }
        }
      }
    })

    deleteConditions = this.rtrim(this.rtrim(deleteConditions, ' && '), ' || ')

    let disableDeleteButton = false

    if (_.isEmpty(deleteConditions) && _.isEmpty(deleteCustomConditions) && !_.isEmpty(deleteRefidConditions) &&
      actionPermission.includes('Delete') && this.check(deleteRefidConditions)) {
      disableDeleteButton = true
    }

    if (_.isEmpty(deleteConditions) && !_.isEmpty(deleteCustomConditions) && _.isEmpty(deleteRefidConditions) &&
      actionPermission.includes('Delete') && this.check(deleteCustomConditions)) {
      disableDeleteButton = true
    }

    if (_.isEmpty(deleteConditions) && !_.isEmpty(deleteCustomConditions) && !_.isEmpty(deleteRefidConditions) &&
      actionPermission.includes('Delete') && this.check(deleteCustomConditions) && this.check(deleteRefidConditions)) {
      // disableDeleteButton = true;
      const blockConditionOperator = _.isEmpty(relationBetweenConditionBlock['delete_refid']) ? '&&' : relationBetweenConditionBlock['delete_refid']
      switch (blockConditionOperator) {
        case '||':
          if (this.check(deleteRefidConditions) || this.check(deleteCustomConditions)) {
            disableDeleteButton = true
          }
          break
        default:
          if (this.check(deleteRefidConditions) && this.check(deleteCustomConditions)) {
            disableDeleteButton = true
          }
          break
      }
    }

    /* if (_.isEmpty(deleteConditions) && !_.isEmpty(deleteCustomConditions) && !_.isEmpty(deleteRefidConditions) &&
      actionPermission.includes("Delete") && this.check(deleteCustomConditions) && this.check(deleteRefidConditions)) {
      disableDeleteButton = true
    } */

    if (!_.isEmpty(deleteConditions) && deleteCustomConditions == '' && deleteRefidConditions == '' &&
      actionPermission.includes('Delete') && this.check(deleteConditions)) {
      disableDeleteButton = true
    }

    if (!_.isEmpty(deleteConditions) && _.isEmpty(deleteCustomConditions) && !_.isEmpty(deleteRefidConditions) &&
      actionPermission.includes('Delete')) {
      // disableDeleteButton = true;
      const blockConditionOperator = _.isEmpty(relationBetweenConditionBlock['delete_id']) ? '&&' : relationBetweenConditionBlock['delete_id']
      switch (blockConditionOperator) {
        case '||':
          if (this.check(deleteConditions) || this.check(deleteRefidConditions)) {
            disableDeleteButton = true
          }
          break
        default:
          if (this.check(deleteConditions) && this.check(deleteRefidConditions)) {
            disableDeleteButton = true
          }
          break
      }
    }

    /* if (!_.isEmpty(deleteConditions) && _.isEmpty(deleteCustomConditions) && !_.isEmpty(deleteRefidConditions) &&
      actionPermission.includes("Delete") && this.check(deleteConditions) && this.check(deleteRefidConditions)) {
      disableDeleteButton = true;
    } */

    if (!_.isEmpty(deleteConditions) && !_.isEmpty(deleteCustomConditions) && _.isEmpty(deleteRefidConditions) &&
      actionPermission.includes('Delete')) {
      // disableDeleteButton = true;
      const blockConditionOperator = _.isEmpty(relationBetweenConditionBlock['delete_id']) ? '&&' : relationBetweenConditionBlock['delete_id']
      switch (blockConditionOperator) {
        case '||':
          if (this.check(deleteConditions) || this.check(deleteCustomConditions)) {
            disableDeleteButton = true
          }
          break
        default:
          if (this.check(deleteConditions) && this.check(deleteCustomConditions)) {
            disableDeleteButton = true
          }
          break
      }
    }

    /* if (!_.isEmpty(deleteConditions) && !_.isEmpty(deleteCustomConditions) && _.isEmpty(deleteRefidConditions) &&
      actionPermission.includes("Delete") && this.check(deleteConditions) && this.check(deleteCustomConditions)) {
      disableDeleteButton = true;
    } */

    if (!_.isEmpty(deleteConditions) && !_.isEmpty(deleteCustomConditions) && !_.isEmpty(deleteRefidConditions) &&
      actionPermission.includes('Delete')) {
      // disableDeleteButton = true;
      const blockIdConditionOperator = _.isEmpty(relationBetweenConditionBlock['delete_id']) ? '&&' : relationBetweenConditionBlock['delete_id']
      const blockRefIdConditionOperator = _.isEmpty(relationBetweenConditionBlock['delete_refid']) ? '&&' : relationBetweenConditionBlock['delete_refid']
      switch (true) {
        case ((blockIdConditionOperator == '||') && (blockRefIdConditionOperator == '||')):
          if (this.check(deleteConditions) || this.check(deleteRefidConditions) || this.check(deleteCustomConditions)) {
            disableDeleteButton = true
          }
          break
        case (blockIdConditionOperator == '||'):
          if ((this.check(deleteConditions) || this.check(deleteRefidConditions)) && this.check(deleteCustomConditions)) {
            disableDeleteButton = true
          }
          break
        case (blockRefIdConditionOperator == '||'):
          if (this.check(deleteConditions) && (this.check(deleteRefidConditions) || this.check(deleteCustomConditions))) {
            disableDeleteButton = true
          }
          break
        default:
          if (this.check(deleteConditions) && this.check(deleteCustomConditions) && this.check(deleteRefidConditions)) {
            disableDeleteButton = true
          }
          break
      }
    }

    /* if (!_.isEmpty(deleteConditions) && !_.isEmpty(deleteCustomConditions) && !_.isEmpty(deleteRefidConditions) &&
      actionPermission.includes("Delete") && this.check(deleteConditions) && this.check(deleteCustomConditions) && this.check(deleteRefidConditions)) {
      disableDeleteButton = true;
    } */

    return disableDeleteButton
  },
  check: function (conditions: string): any {
    const code = '' + conditions + ';'
    // eslint-disable-next-line no-eval
    return eval(code)
  },
  inArray: function (needle: any, haystack: any) {
    const length = haystack.length
    for (let i = 0; i < length; i++) {
      if (haystack[i] == needle) return true
    }
    return false
  },
  rtrim: function (str: any, chr: any) {
    const rgxtrim = (!chr) ? new RegExp('\\s+$') : new RegExp(chr + '+$')
    return str.replace(rgxtrim, '')
  }
}
